import React from 'react';

function NewPage() {
  return <div>NewPage</div>;
}

export default NewPage;
